<template>
  <div class="wrapper" v-if="!isSso">

    <div class="content">
      <b-container>
        <b-row class="justify-content-md-center ">
          <b-col col md="4"  class="login-wrapper">
            <b-row class="no-padding">
              <b-col class="logo-header">
                <img src="../assets/randd.png" alt="randd Logo"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <font-awesome-icon icon="envelope" />
                <label for="emailAddress">Email Address:</label>
                <b-form-input
                  v-model="emailAddress"
                  id="emailAddress"
                  v-on:keyup.enter="onEnter"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <font-awesome-icon icon="key" />
                <label for="password">Password:</label>
                <b-form-input
                  type="password"
                  id="password"
                  v-model="password"
                  v-on:keyup.enter="onEnter"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="right"
                ><b-button @click="doLogin" variant="dark" type="submit"
                  ><font-awesome-icon icon="unlock" />&nbsp;Log In</b-button
                ></b-col
              >
            </b-row>

            <b-row >
              <Feedback ref="loginFeedback" />
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer />
  </div>
</template>
<script>
import router from "@/router";
import Feedback from "@/components/shared/Feedback.vue";
import Footer from "@/components/shared/Footer.vue";

export default {
  name: "Auth",
  components: { Feedback, Footer },
  data() {
    return {
      userId: null,
      token: null,
      emailAddress: null,
      password: null,
      error: false,
      isSso: true,
      companyId: null
    };
  },
  mounted() {

    this.userId = this.$route.params.userId;
    this.token = this.$route.params.token;
    this.companyId = this.$route.params.companyId;

    if (
      (this.$route.name === "SSO" || this.$route.name === "CompanySSO") &&
      this.userId != null &&
      this.token != null
    ) {
      this.validateToken();
    } else {
      this.isSso = false;
      if (this.$route.name === "Logout") {
        this.doLogout();
      }
    }
  },
  methods: {
    async validateToken() {
      this.$http
        .post("/Auth/SSO", {
          userId: this.userId,
          token: this.token,
        })
        .then((response) => {
          if (response.status == 200) {
            this.setTokenAndRedirect(response.data);
          } else {
            // Invalid SSO token
            router.push("/login");
          }
        });
    },
    async doLogin() {
      this.$refs.loginFeedback.clear();

      this.$http
        .post("/Auth/Login", {
          emailAddress: this.emailAddress,
          password: this.password,
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.duo_redirect_url) {
              localStorage.setItem('duoState', JSON.stringify(response.data));
              window.location.href = response.data.duo_redirect_url;
            } else {
              this.setTokenAndRedirect(response.data);
            }
          } else {
            this.error = true;
            this.$refs.loginFeedback.showError(
              "Login failed",
              ": please check your email address and password."
            );
          }
        })
        .catch(() => {
          this.$refs.loginFeedback.showError(
            "Login failed",
            ": please check your email address and password."
          );
        });
    },
    async setTokenAndRedirect(jwt) {
      this.$store.commit("setUser", {
        access_token: jwt.access_token,
        expires_in: jwt.expires_in,
        refresh_token: jwt.refresh_token,
      });
      // dispatch check for refresh token
      this.$store.dispatch("autoRefresh");

      if (this.companyId) {
        router.push(`/company/${this.companyId}`);
      } else {
        router.push("/dashboard");
      }

    },
    doLogout() {
      this.$store.commit("clearUser");
      this.$store.commit("clearRefresh");
      router.push("/login");
    },
    onEnter: function () {
      this.doLogin();
    },
  },
};
</script>

<style scoped>
.logo-header {
  background-color: #252658;
  text-align: left;
  padding: 10px;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.row {
  padding-top: 16px;
}
label {
  padding-left: 10px;
}
.right {
  text-align: right;
}
.wrapper {
  height: 100%;
}

.content {
  min-height: 100%;
  padding-top: 72px;
  padding-bottom: 70px;
  margin-top: 0;
  margin-bottom: -60px;

}

.no-padding {
  padding:0;
}

.login-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  background-color: white;
}
</style>
